import React from 'react';
import { IconProps } from '../types';

export const BusinessConsultingIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8890_7594)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.66659 3.99992C1.66659 1.97487 3.30821 0.333252 5.33325 0.333252C7.3583 0.333252 8.99992 1.97487 8.99992 3.99992C8.99992 6.02496 7.3583 7.66658 5.33325 7.66658C3.30821 7.66658 1.66659 6.02496 1.66659 3.99992ZM5.33325 2.33325C4.41278 2.33325 3.66658 3.07944 3.66658 3.99992C3.66658 4.92039 4.41278 5.66658 5.33325 5.66658C6.25373 5.66658 6.99992 4.92039 6.99992 3.99992C6.99992 3.07944 6.25373 2.33325 5.33325 2.33325Z"
                fill={color}
            />
            <path
                d="M10.3333 11.6666V31.6666H8.33325V11.6666H3.99992C3.55789 11.6666 3.13397 11.8422 2.82141 12.1547C2.50885 12.4673 2.33325 12.8912 2.33325 13.3333V31.6666H0.333252V13.3333C0.333252 12.3608 0.719561 11.4282 1.40719 10.7405C2.09483 10.0529 3.02746 9.66658 3.99992 9.66658H20.9999V11.6666H10.3333Z"
                fill={color}
            />
            <path
                d="M12.3333 2.99992H31.6666V22.3333H24.183L27.5856 30.2727L25.7473 31.0605L22.007 22.3333H13.6666V20.3333H29.6666V4.99992H12.3333V2.99992Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8890_7594">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
